import {createSvgIcon} from '@yandex-delivery/blocks/icons/utils'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import React from 'react'

const className = css`
  inline-size: ${spacing(10.625)};
  block-size: ${spacing(10.5)};
`
export default createSvgIcon(
  <svg
    className="footer__icon"
    fill="none"
    height="40"
    viewBox="0 0 40 40"
    width="40"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M33.75 1.25H6.25C3.48858 1.25 1.25 3.48858 1.25 6.25V33.75C1.25 36.5114 3.48858 38.75 6.25 38.75H33.75C36.5114 38.75 38.75 36.5114 38.75 33.75V6.25C38.75 3.48858 36.5114 1.25 33.75 1.25ZM6.25 0C2.79822 0 0 2.79822 0 6.25V33.75C0 37.2018 2.79822 40 6.25 40H33.75C37.2018 40 40 37.2018 40 33.75V6.25C40 2.79822 37.2018 0 33.75 0H6.25Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      d="M22.9326 24.1177C22.9326 23.7928 22.6694 23.5294 22.3448 23.5294C22.0201 23.5294 21.7569 23.7928 21.7569 24.1177C21.7569 25.0923 22.5465 25.8824 23.5204 25.8824H25.8717C26.8457 25.8824 27.6352 25.0923 27.6352 24.1177C27.6352 23.7928 27.3721 23.5294 27.0474 23.5294C26.7228 23.5294 26.4596 23.7928 26.4596 24.1177C26.4596 24.4425 26.1964 24.7059 25.8717 24.7059H23.5204C23.1958 24.7059 22.9326 24.4425 22.9326 24.1177Z"
      fill="white"
    />
    <path
      clipRule="evenodd"
      d="M10.5882 8.23531C10.5882 7.58556 11.1149 7.05884 11.7647 7.05884H23.5196C24.1694 7.05884 24.6961 7.58556 24.6961 8.23531V21.1765H28.5184C29.1246 21.1765 29.6315 21.6377 29.6888 22.2416L30.5828 31.6534C30.6484 32.344 30.1057 32.9412 29.4124 32.9412H11.7647C11.1149 32.9412 10.5882 32.4145 10.5882 31.7647V8.23531ZM12.9395 21.1765C12.2902 21.1765 11.7639 20.6501 11.7639 20.0008V18.8227C11.7639 18.1734 12.2902 17.6471 12.9395 17.6471C13.5888 17.6471 14.1152 18.1734 14.1152 18.8227V20.0008C14.1152 20.6501 13.5888 21.1765 12.9395 21.1765ZM28.5184 22.353H20.8876L19.9936 31.7647H29.4124L28.5184 22.353Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>,
  'Door',
  {viewBox: '0 0 40 40', className},
)
